var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.315 13.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.937 0-4.293 9.893L32.355 0h-2.218v12.329h2.11V4.775l3.34 7.554H37.7l3.337-7.554v7.554h2.112V0z",
    "data-name": "Fill 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.315 12.329h2.055V0h-2.055z",
    "data-name": "Fill 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m62.916 5.472-1.314-.216c-1.448-.216-2.179-.792-2.179-1.71 0-.864.787-1.6 2.29-1.6a4.376 4.376 0 0 1 3.4 1.654l1.561-1.585A6.568 6.568 0 0 0 61.808 0a5.35 5.35 0 0 0-3.286.989A3.091 3.091 0 0 0 57.167 3.6c0 2.034 1.448 3.312 3.947 3.744l1.6.251c1.446.235 2.16.848 2.16 1.8 0 .989-.9 1.674-2.5 1.674a4.683 4.683 0 0 1-4-1.945L56.849 10.6a6.5 6.5 0 0 0 5.241 2.412 6.061 6.061 0 0 0 3.683-1.008 3.174 3.174 0 0 0 1.35-2.645c0-2.071-1.37-3.457-4.207-3.889",
    "data-name": "Fill 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.288 12.329h8.9v-1.9h-6.751V7h6.451V5.084h-6.451V1.9h6.751V0h-8.9z",
    "data-name": "Fill 7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.215 0v8.723L91.125 0h-2.084v12.329h2.084V3.641l6.09 8.688h2.1V0z",
    "data-name": "Fill 9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.055 8.904a2.055 2.055 0 1 0 2.055 2.055 2.055 2.055 0 0 0-2.055-2.055",
    "data-name": "Fill 11"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.959 8.904a2.055 2.055 0 1 0 2.055 2.055 2.055 2.055 0 0 0-2.055-2.055",
    "data-name": "Fill 13"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.166 0A2.055 2.055 0 1 0 8.22 2.056 2.056 2.056 0 0 0 6.166 0",
    "data-name": "Fill 15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.07 0a2.055 2.055 0 1 0 2.054 2.056A2.056 2.056 0 0 0 15.07 0",
    "data-name": "Fill 17"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.177 8.904a2.055 2.055 0 1 0 2.056 2.055 2.055 2.055 0 0 0-2.056-2.055",
    "data-name": "Fill 19"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.055 8.904a2.055 2.055 0 1 0 2.055 2.055 2.055 2.055 0 0 0-2.055-2.055",
    "data-name": "Fill 28"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.959 8.904a2.055 2.055 0 1 0 2.055 2.055 2.055 2.055 0 0 0-2.055-2.055",
    "data-name": "Fill 30"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.166 0A2.055 2.055 0 1 0 8.22 2.056 2.056 2.056 0 0 0 6.166 0",
    "data-name": "Fill 32"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.07 0a2.055 2.055 0 1 0 2.054 2.056A2.056 2.056 0 0 0 15.07 0",
    "data-name": "Fill 34"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.177 8.904a2.055 2.055 0 1 0 2.056 2.055 2.055 2.055 0 0 0-2.056-2.055",
    "data-name": "Fill 36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2eabd70c53692c836211c60ec1d7e8aa.svg";
export { ForwardRef as ReactComponent };